import { logEvent } from './logGaEvent'

export const logIconTray = () => {
  logEvent('internal_element', {
    type: 'icon_pill_dropdown',
    page_name: 'listings',
    product_name: 'air',
  })
}
